$('[data-featured]').slick({
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    adaptiveHeight: false,
    arrows: false,
    draggable: true,
    autoplay: true,
    autoplaySpeed: 10000,
    responsive: [
        {
            breakpoint: 850,
            settings: {
                slidesToShow: 2}
        },
        {
            breakpoint: 650,
            settings: {
                slidesToShow: 1
            }
        }
        ]
});
